/* This component is header component which is reusable 
   for all components 
   Created by: Nikhil Gaykhe
*/

import React, { useEffect, useState } from 'react';
import SideNav from './SideNavigation/SideNav';
import 'Home/Header/header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import Axios from 'axios';
import NotificationPanel from 'Home/CommonResources/NotificationPanel/NotificationPanel';
import UserActivityPanel from 'Home/CommonResources/UserActivityPanel/UserActivityPanel';
import { toast } from 'react-toastify';
import HomeApiCall from 'HomeApiCall';

const Header = (props) => {
    const pointsData = config.pointsInfo;

    // VARIABLES TO VIEW MODULE LIST POPOVER
    const [showFilter, setShowFilter] = useState(false);
    const [moduleListArray, setModuleListArray] = useState([]);
    const [searchModule, setSearchModule] = useState('');
    const [checkedValue, setCheckedValue] = useState([]);
    const [temporaryModuleListArray, setTemporaryModuleListArray] = useState([]);

    // VARIABLES FOR SUCCESS MODAL
    const [successModal, setSuccessModal] = useState(false);
    const [moduleListModal, setModuleListModal] = useState(false);
    const [userInfoModal, setUserInfoModal] = useState(false);
    const [ActivityLogModal, setActivityLogModal] = useState(false);
    const [notificationModal, setNotificationModal] = useState(false);
    const [successModalType, setSuccessModalType] = useState('');
    const [subscriptionWaring, setSubscriptionWaring] = useState('');
    const [userAcceptedHTML, setUserAcceptedHTML] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const [unReadMessageCount, setUnReadMessageCount] = useState(0);
    const [unReadUpdateReadMessageCount, setUnReadMessageUpdateCount] = useState(0);
    const [isNotificationModalUpdate, setIsNotificationModalUpdate] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);



    const imageExtensions = ['jpeg', 'jpg', 'png'];
    useEffect(() => {        
        apiCallToGetWebNotification();
        apiCallToGetUpdateDetails();
    }, [notificationModal,isNotificationModalUpdate]);
    
    //  API CALL TO GET NOTIFICATION
    const apiCallToGetWebNotification = async () => {
        // setIsLoading(true);
        let formData = {
            iid: config.institute_id,
            // userRole: config.instructorRole == "instructor" || config.instructorRole == "employee" || config.instructorRole == "teaching" || config.instructorRole == "nonteaching" ? "instructor" : "learner",
            userRole: config.ParsedInstructorData.role == "faculty" || config.ParsedInstructorData.role == "instructor" || config.ParsedInstructorData.role == "employee" || config.ParsedInstructorData.role == "teaching" || config.ParsedInstructorData.role == "nonteaching" ? "instructor" : "learner",
            userId: config.faculty_id,
            offset: 1,
            limit: 10,
            // iidArray: AdminAccessReducer.iidArray.iidArray
        };
        let jsonResponse = await HomeApiCall.makeApiCall(
            "webNotificationGetNotification",
            formData,
            '/api/webNotification/webNotification.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetWebNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {


                let unReadMessageCount = Number(jsonResponse.APIResult.unReadMessageCount);
                
                setUnReadMessageCount(unReadMessageCount);
                
                // setIsLoading(false);
            } else {
                // setIsLoading(false);
            }
        }


    }
    //  API CALL TO GET UPDATES
    const apiCallToGetUpdateDetails = async () => {
        const requestData = {
            userId: config.faculty_id,
            iid: config.institute_id,


        };
        try {
            const jsonResponse = await HomeApiCall.makeApiCall(
                'pmTool_getSummaryNotificationCount',
                requestData,
                "/api/projectManagement/Queries/pmTool_DocSEMDashBoard.php"
            );
            if (jsonResponse.expired) {
                setTimeout(() => {
                    apiCallToGetUpdateDetails();
                }, 1000);
            } else {
                if (jsonResponse.success) {

                    let updateReadUnCount = Number(jsonResponse.APIResult.unreadNotificationCount);

                    
                    setUnReadMessageUpdateCount(updateReadUnCount);

                } else {
                    toast.error("Something went wrong While getting Announcements")
                }
            }
        } catch (error) {
            toast.error('Something went wrong While getting Announcements:', error);
        }
    };


    useEffect(() => {
        document.getElementById("mySidenav").style.width = "0px";

        //API CALL TO GET MODULE LIST ARRAY
        Axios.get(`${config.RootUrl}/faculty/summary/moduleNavigation.json`).then(res => {
            setModuleListArray(res.data);
            setTemporaryModuleListArray(res.data);
        });

        const onKeyDown = (e) => {
            if (e.ctrlKey && e.keyCode == 32) {
                handleModuleSearch();
            }
        }

        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.removeEventListener("keydown", onKeyDown);

        }
    }, []);

    const handleModuleSearch = () => {

        if (!document.getElementById("moduleSearchSpan").classList.contains('show')) {
            document.getElementById("moduleSearchSpan").classList.add('show');
            document.getElementById("moduleDropdown").classList.add('show');
            document.getElementById("searchModuleInput").focus();

        }
        else {
            document.getElementById("moduleSearchSpan").classList.remove('show');
            document.getElementById("moduleDropdown").classList.remove('show');
        }
    }


    // HANDLE FILTER BY CATEGORY
    const handleFilterByCategory = (e) => {
        let checkedValues = checkedValue;
        if (checkedValues.includes(e.target.value)) {
            checkedValues = checkedValues.filter(name => name != e.target.value);
        } else {
            checkedValues.push(e.target.value);
        }

        setCheckedValue(checkedValues);

        handleFilterByCategoryResponse(checkedValues);
    }

    // HANDLE FILTER BY CATEGORY RESPONSE
    const handleFilterByCategoryResponse = (checkedValues) => {
        let checkedFilterArray = [];

        temporaryModuleListArray.map((module_type) => {
            let isChecked = false;
            for (let i = 0; i < checkedValues.length; i++) {
                if (module_type.moduleType.includes(checkedValues[i])) {
                    isChecked = true;
                }
            }

            if (isChecked) {
                checkedFilterArray.push(module_type);
            }
        });

        if (checkedValues.length == 0) {
            setModuleListArray(temporaryModuleListArray);
        } else {
            setModuleListArray(checkedFilterArray);
        }
    }

    //handleModalOpenClose
    const handleModalOpenClose = (modalName) => {

        if (modalName == "moduleList") {
            setModuleListModal(!moduleListModal);
            setUserInfoModal(false);
            setActivityLogModal(false);
            setNotificationModal(false);
        }
        if (modalName == "userInfo") {
            setUserInfoModal(!userInfoModal);
            setModuleListModal(false);
            setActivityLogModal(false);
            setNotificationModal(false);

        }
        if (modalName == "notification") {
            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(false);
            setNotificationModal(!notificationModal);

        }
        if (modalName == "userActivity") {
            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(!ActivityLogModal);
            setNotificationModal(false);

        }
    }

    // METHOD CALLED TO OPEN SIDE NAVIGATION MENU
    const openNav = () => {
        document.getElementById("mySidenav").style.width = "350px";
    }

    // METHOD TO SIGN OUT
    const userSignOut = () => {
        localStorage.setItem("logout-event", Date.now());
        props.history.push(`${config.RootUrl}/vmlogout.php`)
    }

    if (config.institute_name === '' || config.institute_name === undefined) {
        config.institute_name = 'vmedulife';
    }

    const notificationUpdates = () => {
        setIsNotificationModalUpdate(!isNotificationModalUpdate);
    }

    return (
        <div id="header">
            <div> {/*Navigation bar div */}
                <nav className="navbar navbar-expand-lg navbar-dark" id="header">
                    <div className="college-name">
                        <button className="sidenav-button btn btn-link text-white" id="hamburgerMenu" style={{ fontSize: 16, display: "none" }} type="button" onClick={() => openNav()}><FontAwesomeIcon icon={['fas', 'bars']} size="lg" style={{ fontSize: 20 }} /></button>
                        <a href={config.RootUrl + '/modules/summary/#/'}><p className="college text-white">{ReactHtmlParser(config.institute_name)}</p></a>
                    </div>
                    <div className="user-info">
                        <a href={`${config.RootUrl}/modules/myworkspace/#/`}>
                            <span
                                style={{
                                    width: 'auto',
                                    borderRadius: '20px',
                                    backgroundColor: "#0465AC",
                                    color: '#ffffff',
                                    border: 'none',
                                    textDecoration: 'underline',

                                    padding: '6px',
                                    fontFamily: "'Poppins', sans-serif",
                                    fontSize: '12px',
                                    marginRight: '5px',


                                }}
                            >
                                Switch To New Version
                            </span>
                        </a>
                        <UserActivityPanel ActivityLogModal={ActivityLogModal} handleModalOpenClose={handleModalOpenClose} />
                        {/* <NotificationPanel notificationModal={notificationModal} handleModalOpenClose={handleModalOpenClose} /> */}
                        <div className='header-icon-bg mobileViewNotificationActivity mr-3 p-1 cursor-pointer' style={{ position: "relative", borderRadius: '8px', padding: '2px' }}> 
                            {

                                <span
                                    className="position-absolute d-flex justify-content-center align-items-center shadow-sm "
                                    style={{ borderRadius: '50%', width: '18px', height: '18px', top: '-5px', left: '10px', fontSize: '10px', backgroundColor: '#ff0000' }}
                                >
                                    {
                                        (Number(unReadMessageCount) + Number(unReadUpdateReadMessageCount)) < 99 ? (Number(unReadMessageCount) + Number(unReadUpdateReadMessageCount)) : "99+"
                                    }

                                </span>
                            }
                            <FontAwesomeIcon
                                onClick={() => {
                                    handleModalOpenClose('notification');
                                }}
                                className='text-white' style={{cursor:'pointer'}} size="lg" icon={['fas', 'bell']} />

                        </div>
                        <span
                            className={`dropdown mr-4`}
                            id="moduleSearchSpan">
                            <FontAwesomeIcon style={{ color: 'white', marginLeft: 10, cursor: 'pointer', fontSize: 18 }} size="xl" icon={['fas', 'th']} onClick={() => handleModalOpenClose('moduleList')} />
                            <div class={`dropDownDiv dropdown-menu userDetailsMenu mt-2 ${moduleListModal ? 'show' : ''}`} id="moduleDropdown" aria-labelledby="dropdownMenuButton" style={{ left: '-57vw', width: '60vw', borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px' }} >
                                <div className='row col-md-12 d-flex flex-column'>
                                    <div className='col-md-12 moduleListHeaderDetails row' style={{ padding: 0 }}>
                                        <div className='col-md-4' style={{ padding: 0 }}>
                                            <h4>Modules</h4>
                                        </div>
                                        <div className='col-md-6 mblScreen align-items-center' style={{ padding: 0 }}>
                                            <input
                                                className="form-control mr-sm-2 searchModuleInput"
                                                type="search"
                                                placeholder="Search"
                                                aria-label="Search"
                                                id='searchModuleInput'
                                                onChange={(e) => setSearchModule(e.target.value.toLowerCase())}
                                            />
                                            <span className="dropdown">
                                                <p className="filterModuleButton" data-toggle="dropdown" onClick={() => setShowFilter(!showFilter)}>
                                                    <FontAwesomeIcon icon={['fas', 'filter']} style={{ marginRight: 5 }} />
                                                    Filter
                                                </p>
                                                <div className={showFilter ? "dropDownFilter dropdown-menu moduleTypeMenu show" : " dropdown-menu deleteMenu"} style={{ left: '-31vh', borderRadius: 5 }} aria-labelledby="dropdownMenuButton" onClick={(e) => e.stopPropagation()}>
                                                    <span className="dropdown-item d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                        <input
                                                            className='mr-2'
                                                            type="checkbox"
                                                            onChange={(e) => handleFilterByCategory(e)}
                                                            value="OBE (Outcome Based Education)"
                                                            id="0"
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                        <p className='filterName' > OBE (Outcome Based Education)</p>
                                                    </span>
                                                    <span className="dropdown-item d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                        <input
                                                            className='mr-2'
                                                            type="checkbox"
                                                            onChange={(e) => handleFilterByCategory(e)}
                                                            value="ERP (Enterprise Resource Planning)"
                                                            id="1"
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                        <p className='filterName' > ERP (Enterprise Resource Planning)</p>
                                                    </span>
                                                    <span className="dropdown-item d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                        <input
                                                            className='mr-2'
                                                            type="checkbox"
                                                            onChange={(e) => handleFilterByCategory(e)}
                                                            value="Teaching & Learning"
                                                            id="2"
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                        <p className='filterName' > Teaching & Learning</p>
                                                    </span>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="dropdown-divider"></div>
                                    <div className='row customScrollDiv' style={{ maxHeight: '46vh', overflowY: 'scroll' }} >
                                        {
                                            moduleListArray.filter((moduleName) =>
                                                moduleName.title.toLowerCase().includes(searchModule)).length == 0 ?
                                                <p style={{ fontSize: 14, color: '#818181' }}>Any result is not available as per your applied filter. Please alter your selection text.</p>
                                                :
                                                moduleListArray.filter((moduleName) =>
                                                    moduleName.title.toLowerCase().includes(searchModule)).map((item) => {
                                                        return (
                                                            <a className='moduleItems col-md-4 col-sm-12' href={`${config.RootUrl}${item.url}`} style={{ textDecoration: 'none' }}>
                                                                <div className='moduleListIcon'>
                                                                    <FontAwesomeIcon href={`${config.RootUrl}${item.url}`} color="black" icon={[`${item.iconType}`, `${item.iconName}`]} />
                                                                </div>
                                                                <b className='menuText titleName'>{item.title}</b>
                                                            </a>

                                                        )
                                                    })
                                        }
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span className="award-points">
                            <span className="awards badge-pill" style={{ display: "inline-flex", paddingTop: 0, alignItems: "center" }}>
                                {pointsData}<FontAwesomeIcon className="award-icon" icon={['fas', 'trophy']} size="lg" color="#FF9900" />
                            </span>
                        </span>
                        <div className="streams-user-info">
                            <span className="dropdown mr-4">
                                {
                                    imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
                                        <img src={config.userPic} className="admin" style={{ cursor: 'pointer' }} onClick={() => handleModalOpenClose('userInfo')} />
                                        :
                                        <FontAwesomeIcon
                                            icon={['fas', 'user-circle']}
                                            size="lg"
                                            style={{ fontSize: 30, cursor: 'pointer' }}
                                            color="#fff"
                                            onClick={(e) => handleModalOpenClose('userInfo')}

                                        />
                                }
                                <div class={`dropDownDiv dropdown-menu userDetailsMenu mt-2 ${userInfoModal ? 'show' : ''}`} id="moduleDropdown" aria-labelledby="dropdownMenuButton" style={{ left: '-17vw', width: '20vw', borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px' }} >
                                    <div className="userName-Image">
                                        {
                                            imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
                                                <img src={config.userPic} className="admin" data-toggle="dropdown" />
                                                :
                                                <FontAwesomeIcon
                                                    icon={['fas', 'user-circle']}
                                                    size="lg"
                                                    style={{ fontSize: 30 }}
                                                    data-toggle="dropdown"
                                                />
                                        }
                                        <p style={{ fontSize: 14, fontWeight: 'bold' }}>{config.instructorInfo.FirstName} {config.instructorInfo.LastName}</p>
                                    </div>
                                    <hr />
                                    <div className="userEmailId">
                                        <FontAwesomeIcon icon={['far', 'envelope']} style={{ width: 20, fontSize: 18 }} />
                                        <p style={{ fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis' }} title={config.emailId}>{config.emailId}</p>
                                    </div>
                                    <div className="userAccessId">
                                        <FontAwesomeIcon icon={['far', 'id-badge']} style={{ width: 20, fontSize: 18 }} />
                                        <p style={{ fontSize: 14 }}>{config.instructorInfo.user_id}</p>
                                    </div>
                                    <hr />
                                    <div className="updateProfileContainer">
                                        <a className="updateProfileLink" href={config.RootUrl + "/faculty/Personalize.php"}>
                                            <p className="updateProfileButton" title="Click to update profile details">
                                                Update Profile
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </span>
                            <a href={`${config.RootUrl}/vmlogout.php?url=${config.instructorInfo.InstituteUrl}`} className="signout" onClick={() => userSignOut()}><FontAwesomeIcon className="signout-icon icon" icon={['fas', 'power-off']} size="lg" />Sign Out</a>
                        </div>
                    </div>
                </nav>
            </div>
            <SideNav />
            {
                notificationModal && <NotificationPanel notificationUpdates={notificationUpdates} notificationModal={notificationModal} handleModalOpenClose={handleModalOpenClose} />
            }
            
        </div>
    );
}

export default Header;